import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { Button, Dropdown, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../axios/axios';
import Cookies from 'js-cookie'; 
import 'bootstrap/dist/css/bootstrap.min.css';

const Navbar = () => {

  const navigate = useNavigate();

  // États locaux pour l'utilisateur et le token
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const userCookie = Cookies.get('auth_user');
    const tokenCookie = Cookies.get('auth_token');
    if (userCookie) {
      try {
        setUser(JSON.parse(userCookie));
      } catch (error) {
        console.error('Erreur de parsing JSON:', error);
      }
    }
    setToken(tokenCookie);
  }, [Cookies.get('auth_user'), Cookies.get('auth_token')]); // Met à jour lorsque les cookies changent

  const logout = (e) => {
      e.preventDefault();
      axios.post("/logout", null, {
          headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          },
      })
      .then((response) => {
          Cookies.remove('auth_token');
          Cookies.remove('auth_user');
          delete axios.defaults.headers.common['Authorization'];
          navigate(`${process.env.PUBLIC_URL}/login`);
      }).catch((error) => {
          console.log(error)
          // setMsg(error)
      });

  }

  return (
      <>
        <header style={{position:"inherit"}}>
          <div className="middle-menu center-text row" style={{height:'auto', margin: 'auto'}}>
              <div className="col-md-4">
    
              </div>
              <div className="col-md-4" style={{textAlign:'center'}}>
                <Link to={`${process.env.PUBLIC_URL}/profile`} className="logo" style={{padding: '0px 0', height:'auto'}}>
                  <img style={{width:'70%', height:'auto'}} src={`${process.env.PUBLIC_URL}/images/logoRIMTIC.png`} alt="Logo" />
                </Link> 
              </div>
              <div className="col-md-4">
              </div>
          </div>
        </header>
        
        <div className="d-flex flex-column align-items-center shadow">
          
          <nav className="navbar navbar-expand-lg navbar-light mt-auto ">
            <div className="container">
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ml-auto">
                  {user && user.role == 1 ?
                  <li className="nav-item"> 
                    <Link className="nav-link" to={`${process.env.PUBLIC_URL}/rim`}>Accueil admin</Link>
                  </li>
                  :
                  <li className="nav-item"> 
                      <Link className="nav-link" to={`${process.env.PUBLIC_URL}/profile`}>Accueil </Link>
                  </li>
                  }


                  {token != null ? 
                  
                    <li className="nav-item">
                      <Dropdown>
                        <Dropdown.Toggle variant="link" id="dropdown-basic">
                          <FontAwesomeIcon icon={faUser} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          
                          <Dropdown.Item onClick={logout}>
                                  <FontAwesomeIcon icon={faSignOutAlt} /> Se déconnecter 
                          </Dropdown.Item>
                          <Dropdown.Item >
                                <Link to={`${process.env.PUBLIC_URL}/modifier-password`} style={{color:'black'}}>
                                  <FontAwesomeIcon icon={faEdit} /> Modifier mot de passe 
                                </Link>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  : null
                  }
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </>


  );
};


export default Navbar;
